import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query PrismicCartSliderQuery($lang: String!) {\n    cartslider(uid: \"cartslider\", lang: $lang) {\n      body {\n        ... on CartsliderBodySlidelist {\n          label\n          fields {\n            image\n            title\n            link\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
export var prismicCartSliderQuery = gql(_templateObject());